import {
	SPACE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE,
	SPACE_ANALYTICS_POPULAR_CONTENT_CARD_EXPERIENCE,
	SPACE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE,
	SPACE_ANALYTICS_ACTIVE_CONTRIBUTORS_CARD_EXPERIENCE,
	SPACE_ANALYTICS_CONTENT_ACTIVITY_TABLE_EXPERIENCE,
	SPACE_ANALYTICS_USER_ACTIVITY_TABLE_EXPERIENCE,
} from '@confluence/experience-tracker';

// The "Screen" name for all the analytics pages is the same! Their events are differentiated
// by attributes: level and type
export const SPACE_ANALYTICS_SCREEN_ANALYTICS_SOURCE = 'analyticsPageScreen';
export const SPACE_ANALYTICS_SCREEN_ANALYTICS_LEVEL = 'space';
export const SPACE_ANALYTICS_POPULAR_CONTENT_CARD_ACTION_KEY = 'popularContent';
export const SPACE_ANALYTICS_ACTIVE_CONTRIBUTION_CARD_ACTION_KEY = 'mostActiveContributors';
export const SPACE_ANALYTICS_ACTIVE_READERS_CARD_ACTION_KEY = 'activeReaders';
// ("type" attribute is the same as the Analytics key for the selected tab, below)

export const SPACE_ANALYTICS_TABS_UI_ID = 'space-analytics-tabs';

// The order should represent the order in the UI
export enum SpaceAnalyticsTab {
	'Overview',
	'Content',
	'Users',
}

// These exports are being duplicated in the /SpaceAnalytics/__playwright__/space-analytics-premium.spec.ts file as they
// cannot be imported; if changed, update there as well
export const ANONYMOUS_USER_DISPLAY_NAME = 'Anonymous';
export const OVERVIEW_CHART_TEST_ID = 'space-analytics-overview-chart';
export const POPULAR_CONTENT_CARD_TEST_ID = 'space-analytics-popular-content-card';
export const MOST_ACTIVE_READERS_CARD_TEST_ID = 'space-analytics-active-readers-card';
export const MOST_ACTIVE_CONTRIBUTORS_CARD_TEST_ID = 'space-analytics-active-contributors-card';
export const CONTENT_TABLE_TEST_ID = 'space-analytics-content-table';
export const USER_TABLE_TEST_ID = 'space-analytics-user-table';

export const SpaceAnalyticsSubExperiences = {
	[SpaceAnalyticsTab.Overview]: [
		SPACE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE,
		SPACE_ANALYTICS_POPULAR_CONTENT_CARD_EXPERIENCE,
		SPACE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE,
		SPACE_ANALYTICS_ACTIVE_CONTRIBUTORS_CARD_EXPERIENCE,
	],
	[SpaceAnalyticsTab.Content]: [SPACE_ANALYTICS_CONTENT_ACTIVITY_TABLE_EXPERIENCE],
	[SpaceAnalyticsTab.Users]: [SPACE_ANALYTICS_USER_ACTIVITY_TABLE_EXPERIENCE],
};

export const POLL_INTERVAL_MS = 1000;
